export type Account = {
  name: string;
  email: string;
  password: string;
};

export const ROLE_ADMIN = 'ADMIN';
export const ROLE_CAMERA_EDIT = 'CAMERA_EDIT';
export const ROLE_PLAYER_EDIT = 'PLAYER_EDIT';
export const ROLE_NO_STATS = 'NO_STATS';
